<kendo-grid [data]="localElementsData" (edit)="editHandler($event)" (cancel)="cancelHandler($event)"
    (save)="saveHandler($event)" (remove)="removeHandler($event)" (add)="addHandler($event)">

    <ng-template kendoGridToolbarTemplate>
        <button kendoGridAddCommand *ngIf="isMultiRow && canAddRow">Add new</button>
        <span class="title">{{ partTitle }}</span>
        <i style="color:darkcyan;" *ngIf="isModelDriven && !isRTADriven">Model driven</i>
        <i style="color:rgb(179, 134, 39);" *ngIf="isRTADriven">RTA driven</i>
    </ng-template>

    <kendo-grid-column field="id" [hidden]="true">
        <ng-template kendoGridCellTemplate let-dataItem let-formGroup="formGroup" let-column="column">
            <input [formControl]="formGroup.get(column.field)">
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="sapMaterialNumber" [hidden]="true">
        <ng-template kendoGridCellTemplate let-dataItem let-formGroup="formGroup" let-column="column">
            <input [formControl]="formGroup.get(column.field)">
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="type" title="Type" [editable]="!isModelDriven || isNewRow">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-column="column">
            <kendo-dropdownlist [data]="picklistOptions" [formControl]="formGroup.get('sapMaterialNumber')"
                valueField="value" textField="text" [valuePrimitive]="true"
                (valueChange)="onTypeSelectionChange($event, formGroup)">
            </kendo-dropdownlist>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="quantity" title="Qty" [width]="100" editor="numeric" [editable]="!isRTADriven">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-column="column">
            <kendo-numerictextbox [formControl]="formGroup.get(column.field)" [min]="0" [step]="1" [decimals]="3"
                [restrictDecimals]="true" [spinners]="false">
            </kendo-numerictextbox>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column [width]="150" *ngIf="!isRTADriven">
        <ng-template kendoGridCellTemplate let-isNew="isNew">
            <div style="display: inline-flex;">
                <button kendoGridEditCommand [primary]="true">Edit</button>
                <button kendoGridRemoveCommand>Remove</button>
                <button kendoGridSaveCommand>{{ isNew ? "Save" : "Update" }}</button>
                <button kendoGridCancelCommand>Cancel</button>
            </div>
        </ng-template>
    </kendo-grid-command-column>
</kendo-grid>